export default {
    isAuthenticated(state) {
        return state.token != null
    },
    getMenu(state) {
        return state.menu;
    }
};
